<template>
    <div>
        <div class="file-table-container">
            <table style="width:100%">
                <tr v-for="(eventAttachment, index) in model.attach_file_list" :key="index">
                    <td style="width:30%;">
                        <FileView :resource="eventAttachment" @click="onViewFile(index)" />
                    </td>
                    <td style="width:50%;" class="mt-2" :class="{ 'text-red': eventAttachment.invalid_file }">
                        {{ eventAttachment.name }}
                    </td>
                    <td style="width:20%;">
                        <button @click.prevent="onDownloadFile(eventAttachment)"
                            class="ts-bg-blue-500 ts-text-white ts-px-3 ts-py-1 ts-rounded-md hover:ts-bg-blue-600">
                            <i class="fas fa-download"></i> {{ $t('Download') }}
                        </button>
                    </td>
                </tr>
            </table>
        </div>

        <a-modal v-model="showModalFileView" :zIndex="1020" width="40%" :title="$t('eventManagement.viewAttachment')"
            :footer="null" :maskClosable="false">
            <div class="ts-rounded-md group ts-relative ts-text-center ts-justify-between ts-items-center"
                style="height: 70vh;">
                <button @click.prevent="onMoveBack"
                    class="hover:ts-bg-gray-400 ts-absolute ts-left-0 ts-ml-3 ts-bg-gray-300 ts-px-4 ts-py-2 ts-rounded-md">
                    <i class="fas fa-chevron-left ts-text-gray-700"></i>
                </button>
                <button @click.prevent="onMoveNext"
                    class="hover:ts-bg-gray-400 ts-absolute ts-right-0 ts-mr-3 ts-bg-gray-300 ts-px-4 ts-py-2 ts-rounded-md">
                    <i class="fas fa-chevron-right ts-text-gray-700"></i>
                </button>
                <ViewModal :fileResource="currentViewFileResource" />
            </div>
        </a-modal>
    </div>
</template>


<script>
import FileView from './file-viewer.vue'
import ViewModal from './view-modal.vue'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'

export default {
    name: 'attachFileShow',
    components: { FileView, ViewModal },
    props: ['value', 'editData'],
    data() {
        return {
            showModalFileView: false,
            currentViewIndex: 0,
            model: {
                attach_file_list: []
            }
        }
    },
    created() {
        if (this.value && Array.isArray(this.value.event_attachments)) {
            this.model.attach_file_list = this.value.event_attachments.map(el => ({
                event_att_id: el.event_att_id,
                name: el.attach_file_name,
                type: el.attach_file_mime_type,
                progressing: 100,
                invalid_file: false,
                file: el.attach_file_path,
                attach_file_path: el.attach_file_path,
                uploaded: true,
                storage_path: el.storage_path
            }))
        }
    },
    computed: {
        currentViewFileResource() {
            return this.model.attach_file_list[this.currentViewIndex] || null
        }
    },
    methods: {
        ...mapActions('eventManagement', ['removeFileUploaded']),

        onRemoveFile(index, record) {
            if (record.event_att_id > 0) {
                this.removeFileUploaded({
                    event_att_id: record.event_att_id,
                    attach_file_path: record.attach_file_path
                })
            }
            this.model.attach_file_list.splice(index, 1)
        },

        onViewFile(index) {
            this.showModalFileView = true
            this.currentViewIndex = index
        },

        onMoveBack() {
            this.currentViewIndex =
                this.currentViewIndex - 1 >= 0
                    ? this.currentViewIndex - 1
                    : this.model.attach_file_list.length - 1
        },

        onMoveNext() {
            this.currentViewIndex =
                this.currentViewIndex + 1 < this.model.attach_file_list.length
                    ? this.currentViewIndex + 1
                    : 0
        },

        onDownloadFile(eventAttachment) {
            FileDownload(eventAttachment.storage_path)

        }
    }

}
</script>
